import React, { useState } from "react";
import styles from "./Warehouse.module.css";

const Reports = () => {
  const initialPermissions = [
    { name: "Отчёты ККМ (мобильное приложение)", columns: ["view"] },
    { name: "X отчёты", columns: ["view"] },
    { name: "Z отчёты", columns: ["view"] },
  ];

  const [terminalAccess, setTerminalAccess] = useState(false);
  const [permissions, setPermissions] = useState(() => {
    const obj = {};
    initialPermissions.forEach((item) => {
      obj[item.name] = {};
      item.columns.forEach((col) => {
        obj[item.name][col] = false;
      });
    });
    return obj;
  });

  const handleCheckboxChange = (row, key) => {
    setPermissions({
      ...permissions,
      [row]: {
        ...permissions[row],
        [key]: !permissions[row][key],
      },
    });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <label>Название роли</label>
        <input type="text" className={styles.roleInput} />

        <div className={styles.terminalWrapper}>
          <label className={styles.terminalLabel}>
            <label className={styles.checkboxContainer}>
              <input
                type="checkbox"
                checked={terminalAccess}
                onChange={() => setTerminalAccess(!terminalAccess)}
              />
              <span className={styles.customCheckbox}></span>
            </label>
            <span className={styles.text}>Доступ только в терминал</span>
          </label>
        </div>
      </div>

      <table className={styles.permissionTable}>
        <thead>
          <tr>
            <th>Название</th>
            <th>Просмотр</th>
            <th>Создать</th>
            <th>Изменить</th>
            <th>Удалить</th>
          </tr>
        </thead>
        <tbody>
          {initialPermissions.map((item) => (
            <tr key={item.name}>
              <td>{item.name}</td>
              {["view", "create", "edit", "delete"].map((col) => (
                <td key={col}>
                  {item.columns.includes(col) ? (
                    <label className={styles.checkboxContainer}>
                      <input
                        type="checkbox"
                        checked={permissions[item.name][col] || false}
                        onChange={() => handleCheckboxChange(item.name, col)}
                      />
                      <span className={styles.customCheckbox}></span>
                    </label>
                  ) : null}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      <button className={styles.saveButton}>Сохранить</button>
    </div>
  );
};

export default Reports;
